import { Star, Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselPrevious, CarouselNext } from "@/components/ui/carousel";
import { Reveal } from "@/lib/motion";

const TESTIMONIALS = [
  {
    name: "Marcus T.",
    role: "Uber driver · Orlando",
    quote: "No credit check, no hassle. I was driving the same day I called — the Tesla practically pays for itself.",
  },
  {
    name: "Jasmine R.",
    role: "Lyft & DoorDash",
    quote: "The weekly rate fits my budget and 200 miles a day is more than enough for all my shifts.",
  },
  {
    name: "David O.",
    role: "Travel nurse · Kissimmee",
    quote: "Booked the Sonata for a 13-week assignment. Deposit came back fast, zero surprises.",
  },
  {
    name: "Keisha W.",
    role: "Instacart shopper",
    quote: "They answered my text in minutes. Easiest rental I've ever done in Orlando, hands down.",
  },
  {
    name: "Andre B.",
    role: "Uber & Grubhub",
    quote: "The car was clean, charged, and ready on time. The whole rental process was easy from start to finish.",
  },
];

export const Testimonials = () => (
  <section id="reviews" data-testid="testimonials-section" className="bg-secondary py-24 md:py-32 overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal className="max-w-2xl mb-12">
        <p className="text-gold-dark text-xs font-bold uppercase tracking-[0.3em] mb-4">Driver Stories</p>
        <h2 className="font-heading font-bold text-navy text-4xl sm:text-5xl lg:text-[3.4rem] tracking-tight leading-[1.02]">
          Loved by Orlando drivers.
        </h2>
        <p className="mt-5 text-muted-foreground text-base md:text-lg leading-relaxed">
          Rideshare drivers, delivery pros, and travel nurses keep coming back. Here's why.
        </p>
      </Reveal>

      <Reveal delay={0.1}>
        <Carousel opts={{ loop: true, align: "start" }} className="w-full" data-testid="testimonials-carousel">
          <CarouselContent className="-ml-4">
            {TESTIMONIALS.map((t, i) => (
              <CarouselItem key={t.name} className="pl-4 md:basis-1/2 lg:basis-1/3">
                <figure
                  data-testid={`testimonial-card-${i}`}
                  className="h-full rounded-3xl bg-white border border-navy/10 p-7 flex flex-col shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
                >
                  <Quote className="w-8 h-8 text-gold" />
                  <div className="mt-3 flex gap-1" aria-label="5 out of 5 stars">
                    {[...Array(5)].map((_, s) => (
                      <Star key={s} className="w-4 h-4 text-gold fill-gold" />
                    ))}
                  </div>
                  <blockquote className="mt-4 text-navy/90 text-base leading-relaxed flex-1">"{t.quote}"</blockquote>
                  <figcaption className="mt-6 pt-4 border-t border-navy/10">
                    <p className="font-heading font-bold text-navy">{t.name}</p>
                    <p className="text-sm text-muted-foreground">{t.role}</p>
                  </figcaption>
                </figure>
              </CarouselItem>
            ))}
          </CarouselContent>
          <div className="mt-8 flex gap-3">
            <CarouselPrevious data-testid="testimonial-prev" className="static translate-y-0 h-11 w-11 rounded-full border-navy/20 text-navy hover:bg-navy hover:text-white" />
            <CarouselNext data-testid="testimonial-next" className="static translate-y-0 h-11 w-11 rounded-full border-navy/20 text-navy hover:bg-navy hover:text-white" />
          </div>
        </Carousel>
      </Reveal>
    </div>
  </section>
);
